import { gql, useQuery } from '@apollo/client';
import { get as dig } from 'lodash';

import useCompanyBillingStatus from 'components/billing/useCompanyBillingStatus';
import { canAccessFeature, FEATURES } from 'helpers/features';

const COMPANY_LOGO_QUERY = gql`
  query CompanyLogo {
    viewer {
      id
      company {
        id
        logo(variants: [ORIGINAL]) {
          variant
          uri
        }
      }
    }
  }
`;

const useLogoSticker = () => {
  const { loading, error, data } = useQuery(COMPANY_LOGO_QUERY);
  const { featureSet } = useCompanyBillingStatus();

  if (loading || error) {
    return { ready: false };
  }

  const src = dig(data, 'viewer.company.logo[0].uri');

  const canAccessLogoStickers = canAccessFeature(
    featureSet,
    FEATURES.LOGO_STICKERS,
  );

  return {
    ready: true,
    src,
    hasBeenUploaded: !!src,
    canAccessLogoStickers,
  };
};

export default useLogoSticker;
